import React from 'react';
import { IntlProvider } from 'react-intl';
import { graphql } from 'gatsby';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Layout from '../components/layout';
import ContentWrapper from '../components/ContentWrapper';

import getMessages from '../locales/getMessages';

const messages = getMessages();

const translate = {
  en: {
    title: 'FAQ',
    subtitle: 'Frequently Ask Questions of EverTool',
  },
  'zh-tw': {
    title: '常見問題',
    subtitle: 'EverTool 的常見問題',
  },
  'zh-cn': {
    title: '常见问题',
    subtitle: 'EverTool 的常见问题',
  },
  ja: {
    title: 'よくある質問',
    subtitle: 'EverToolのよくある質問',
  },
};

const HowToTemplate = ({ data, pageContext }) => {
  const { markdownRemark, site } = data; // data.markdownRemark holds our post data
  const { frontmatter, html } = markdownRemark;
  const { locale, path } = frontmatter;
  const { url } = site.siteMetadata;

  return (
    <Layout
      pageContext={pageContext}
      seo={{
        title: `${translate[locale].title} - EverTool`,
        subtitle: translate[locale].subtitle,
        hreflangs: pageContext.hreflangs,
        url: `${url}${path}`,
        locale,
      }}
    >
      <IntlProvider locale={locale} messages={messages[locale]} textComponent={React.Fragment}>
        <div>
          <Header />
          <ContentWrapper isMarkdown>
            <h1>FAQ</h1>
            <div className="blog-post">
              <div
                className="blog-post-content"
                dangerouslySetInnerHTML={{ __html: html }}
              />
            </div>
          </ContentWrapper>
        </div>
        <Footer />
      </IntlProvider>
    </Layout>
  );
};

export default HowToTemplate;

export const pageQuery = graphql`
  query FaqPath($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      html
      frontmatter {
        path
        locale
      }
    }
    site {
      siteMetadata {
        url
      }
    }
  }
`;
